import Phaser from "phaser";
import { cst } from "../helpers/cst";
import $ from "jquery";

export default class Boot extends Phaser.Scene {
  constructor() {
    super(cst.scenes.boot);
  }

  preload() {
    // load assets
    this.load.image("bg-loading", "assets/backgrounds/bg-loading.png");
  }

  create() {
    this.scene.start(cst.scenes.preload);
  }

  upload() {}
}
